import React, { useState } from 'react';

import TextButton from '~/core/atoms/Buttons/TextButton';
import { MarkdownSection } from '~/core/atoms/MarkdownSection';
import Timeline from '~/core/molecules/Timeline';
import { TimelineEntry } from '~/core/molecules/Timeline/types';
import cn from '~/utils/cn.ts';

const THINKING_TEXT = 'Thinking...';
const baseClasses = 'text-sm text-blue-500 mt-8 mb-4 font-medium';

interface CliveChatThinkingProps {
  timelineEvents: TimelineEntry[];
  title?: string;
}

const CliveChatThinking: React.FC<CliveChatThinkingProps> = ({ timelineEvents, title = THINKING_TEXT }) => {
  const isDone = false; // Replace with actual logic to determine if thinking is done
  const [isOpen, setIsOpen] = useState(false);

  if (isDone) {
    return <div className={baseClasses}>{title}</div>;
  }

  const handleToggle = () => setIsOpen(!isOpen);

  return (
    <div>
      <TextButton className={cn(baseClasses, 'p-0 hover:underline')} onClick={handleToggle}>
        {title}
      </TextButton>
      <div
        className={cn(
          'overflow-hidden transition-all duration-300 ease-in-out',
          isOpen ? 'opacity-100' : 'max-h-0 opacity-0'
        )}
      >
        <div>
          <Timeline
            entries={timelineEvents.map(({ content, ...rest }) => ({
              ...rest,
              content: typeof content === 'string' ? <MarkdownSection markdown={content} /> : content,
            }))}
            className="mt-8"
          />
        </div>
      </div>
    </div>
  );
};

export default CliveChatThinking;
